// Environment configuration
// REACT_APP_SITESUPT_ENV=api-env-prod | api-env-stage | api-env-qa

let api_version = process.env.REACT_APP_SITESUPT_ENV;
const hostname = window.location.hostname;
let env = 'NOT_FOUND';
if (!api_version) {
    switch (hostname) {
        case 'dev.sitesupt.com':
            env = 'dev';
            break;
        case 'qa.sitesupt.com':
            env = 'qa';
            break;
        case 'stage.sitesupt.com':
            env = 'stage';
            break;
        default:
            env = 'prod';
            break;
    }
    api_version = 'api-env-' + env;
} else {
    env = api_version.replace('api-env-', '');
}
console.log(env.toLocaleUpperCase());

env = 'prod';
api_version = 'api-env-prod';

// Base URL configuration based on environment
let baseUrl;
switch (api_version) {
    case 'api-env-prod':
        baseUrl = 'https://l3dk2lydd4.execute-api.us-east-1.amazonaws.com';
        break;
    case 'api-env-stage':
        baseUrl = 'https://lkozpbqtt9.execute-api.us-east-1.amazonaws.com';
        break;
    case 'api-env-qa':
        baseUrl = 'https://l3dk2lydd4.execute-api.us-east-1.amazonaws.com';
        break;
    default:
        baseUrl = 'https://l3dk2lydd4.execute-api.us-east-1.amazonaws.com';
        break;
}

// Google API Key
const googleApiKey = 'AIzaSyD7rYafEbst83cps65IrvmUz61n33z4kIM';

// Google Analytics Configuration
let googleAnalyticsId;
switch (api_version) {
    case 'api-env-prod':
        googleAnalyticsId = 'G-F935M4WR06';
        break;
    case 'api-env-stage':
    case 'api-env-qa':
    default:
        googleAnalyticsId = 'G-N8ZH8ZMT8X';
        break;
}

// Salesforce Configuration
let salesforceUrl = '';
let salesforceOpts = {};
switch (api_version) {
    case 'api-env-prod':
        salesforceUrl = 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8';
        salesforceOpts = {
            site_key: '6LdC4fwUAAAAAC2-76WC_AhRzv3pQl6tChylvrjO',
            orgid: '00D6g000002fS6X',
            gateway_sn: '00N6g00000V9H0B',
            zone: '00N6g00000V9H0D',
            info: '00N6g00000V9H0C',
            order_number: '00NJw000000SKbh'
        };
        break;
    default:
        salesforceUrl = 'https://sitekick--uat.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8';
        salesforceOpts = {
            site_key: '6LdC4fwUAAAAAC2-76WC_AhRzv3pQl6tChylvrjO',
            orgid: '00D7e00000Eeq7f',
            gateway_sn: '00N6g00000V9H0B',
            zone: '00N6g00000V9H0D',
            info: '00N6g00000V9H0C',
            order_number: '00N7e00000AiRRx'
        };
        break;
}

const SiteKickAPIService = {
    ENVIRONMENT: env,
    PATH_SEPARATOR: '/',
    // ==================== Base Configuration ====================
    BASE_URL: baseUrl,
    API_VERSION: api_version,
    GOOGLE_API_KEY: googleApiKey,
    GOOGLE_ANALYTICS_ID: googleAnalyticsId,
    BASE_URL_PROCORE: `https://www.sitesupt.com/procore`,
    BASE_URL_BIM: `https://www.sitesupt.com/rest/v1.0`,

    EMAIL: {
        SEND: `${baseUrl}/${api_version}/send-email/send`
    },

    // ==================== Authentication ====================
    AUTH: {
        AUTHENTICATE: `${baseUrl}/${api_version}/auth/authenticate`,
        RESET_PASSWORD_CHALLENGE: `${baseUrl}/${api_version}/reset-pwd-challenge`,
    },

    // ==================== User Management ====================
    USER: {
        MODIFY: `${baseUrl}/${api_version}/user/modify`,
        UPDATE_CONFIG: `${baseUrl}/${api_version}/user/updateUserConfig`,
    },

    // ==================== Common Table Operations ====================
    COMMON_TABLE_OPERATIONS: {
        BASE: `${baseUrl}/${api_version}/common-table-operations`,

        CUSTOMER: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/customer/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/customer/create`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/customer/modify`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/customer/delete`,
        },

        SITE: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/site/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/site/create`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/site/modify`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/site/delete`,
        },

        LOCATION: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/location/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/location/create`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/location/modify`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/location/delete`,
        },

        DEVICE: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/device/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/device/create`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/device/modify`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/device/delete`,
        },

        USER: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/user/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/user/create`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/user/modify`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/user/delete`,
        },

        DOM: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/dom/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/dom/create`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/dom/modify`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/dom/delete`,
        },

        DOM_GROUP: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/dom_group/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/dom_group/create`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/dom_group/delete`,
        },

        ROLE: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/role/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/role/create`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/role/delete`,
        },

        REMOTE_SENSOR: {
            BASE: `${baseUrl}/${api_version}/common-table-operations/remote_sensor`,
            FETCH: `${baseUrl}/${api_version}/common-table-operations/remote_sensor/fetch`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/remote_sensor/modify`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/remote_sensor/delete`,
        },

        REMOTE_SENSOR_GROUP: {
            BASE: `${baseUrl}/${api_version}/common-table-operations/remote_sensor_group`,
            FETCH: `${baseUrl}/${api_version}/common-table-operations/remote_sensor_group/fetch`,
            CREATE: `${baseUrl}/${api_version}/common-table-operations/remote_sensor_group/create`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/remote_sensor_group/modify`,
            DELETE: `${baseUrl}/${api_version}/common-table-operations/remote_sensor_group/delete`,
        },

        SENSOR_INFO: {
            BASE: `${baseUrl}/${api_version}/sensor-info`,
            FETCH: `${baseUrl}/${api_version}/sensor_info/fetch`,
        },

        EVENT_TMP: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/event_tmp/fetch`,
        },

        COMM_BOX: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/comm_box/fetch`,
        },

        COMMON_CONFIG: {
            FETCH: `${baseUrl}/${api_version}/common-table-operations/commonconfig/fetch`,
            MODIFY: `${baseUrl}/${api_version}/common-table-operations/commonconfig/modify`,
        },
    },

    // ==================== Location & Site Management ====================
    LOCATION: {
        BASE: `${baseUrl}/${api_version}/location`,
        MODIFY: `${baseUrl}/${api_version}/location/modify`,
        CREATE_PANO: `${baseUrl}/${api_version}/location/create_pano`,
    },

    SITE: {
        BASE: `${baseUrl}/${api_version}/site`,
        CONFIG: {
            MODIFY: `${baseUrl}/${api_version}/site-config/modify`,
            UPDATE: `${baseUrl}/${api_version}/site-config/update`,
        },
    },

    // ==================== Camera & Axis Operations ====================
    AXIS_CAMERA: {
        BASE: `${baseUrl}/${api_version}/axis-camera`,
        INFO: `${baseUrl}/${api_version}/axis-camera/info`,
        LATEST_IMAGE: `${baseUrl}/${api_version}/axis-camera/latest-image`,
        STREAM_INFO: `${baseUrl}/${api_version}/axis-camera/stream-info`,
        PTZ_PRESETS: `${baseUrl}/${api_version}/axis-camera/ptz-presets`,
        SAVE_PRESET: `${baseUrl}/${api_version}/axis-camera/save-preset`,
        MODIFY_PRESET: `${baseUrl}/${api_version}/axis-camera/modify-preset`,
        GO_TO_HOME: `${baseUrl}/${api_version}/axis-camera/go2home`,
        RECORDINGS: `${baseUrl}/${api_version}/axis-camera/recordings`,
        SAVE_VIDEO: `${baseUrl}/${api_version}/axis-camera/save-video`,
        DVR_DETAILS: `${baseUrl}/${api_version}/axis-camera/dvr-details`,
        PUBLISH_TRACKING_CONFIG: `${baseUrl}/${api_version}/axis-camera/publish-tracking-config`,
        AXIS_MASKS: `${baseUrl}/${api_version}/axis-camera/axis-masks`,
        TALK_DOWN: `${baseUrl}/${api_version}/axis-camera/talk-down`,
        TURN_ON_STROBE: `${baseUrl}/${api_version}/axis-camera/turnon-strobe`,
        HORN_DEVICES: `${baseUrl}/${api_version}/axis-camera/horn-devices`,
    },

    CAMERA: {
        LIVE_FEED: `${baseUrl}/${api_version}/live-camera-feed`,
        LATEST_LOCATION_IMAGE: `${baseUrl}/${api_version}/latest-location-image`,
    },

    // ==================== Reports ====================
    REPORTS: {
        STANDARD_DAILY: `${baseUrl}/${api_version}/standard-daily-report`,
        PPE: `${baseUrl}/${api_version}/ppe-report`,
        HUMAN_POWER: `${baseUrl}/${api_version}/human-power`,
    },

    // ==================== PDF Reports ====================
    PDF: {
        STANDARD_DAILY: `${baseUrl}/${api_version}/pdf/standard-daily-report`,
        PPE_AWARENESS: `${baseUrl}/${api_version}/pdf/ppe-awareness-daily-report`,
        AFTER_HOURS: `${baseUrl}/${api_version}/pdf/after-hours-visitors-report`,
        ENVIRONMENTAL: `${baseUrl}/${api_version}/pdf/environmental-report`,
        RAIN: `${baseUrl}/${api_version}/pdf/rain-report`,
        WIND: `${baseUrl}/${api_version}/pdf/wind-report`,
        UPTIME: `${baseUrl}/${api_version}/pdf/uptime-report`,
        VEHICLE_TRACKING: `${baseUrl}/${api_version}/pdf/vehicle-tracking-report`,
        MAN_POWER: `${baseUrl}/${api_version}/pdf/man-power-report`,
    },

    EXPORT_PDF: {
        DAILY_REPORT: `${baseUrl}/${api_version}/export-pdf/daily-report`,
        STANDARD_DAILY: `${baseUrl}/${api_version}/export-pdf/standard-daily-report`,
        PPE_AWARENESS: `${baseUrl}/${api_version}/export-pdf/ppe-awareness-daily-report`,
        SENSOR_DETAILS: `${baseUrl}/${api_version}/export-pdf/sensor-details`,
    },

    SAVE_PDF: {
        PPE_AWARENESS: `${baseUrl}/${api_version}/save-pdf/ppe-awareness-daily-report`,
    },

    // ==================== Data & Analytics ====================
    DATA: {
        EXPLORER: `${baseUrl}/${api_version}/data-explorer`,
        ENVIRONMENTAL: `${baseUrl}/${api_version}/environmental-data`,
        SENSOR_INFO: `${baseUrl}/${api_version}/sensor-info`,
        WEATHER: `${baseUrl}/${api_version}/weather`,
        BOUNDING_BOXES: `${baseUrl}/${api_version}/bounding-boxes-info`,
    },

    // ==================== Timelapse & Videos ====================
    TIMELAPSE: {
        BASE: `${baseUrl}/${api_version}/timelaps`,
        SCHEDULER: {
            FETCH: `${baseUrl}/${api_version}/timelaps-scheduler/fetch`,
            ADD: `${baseUrl}/${api_version}/timelaps-scheduler/add`,
            DELETE: `${baseUrl}/${api_version}/timelaps-scheduler/delete`,
        },
        VIDEOS: {
            FETCH: `${baseUrl}/${api_version}/timelapse-videos/fetch`,
            UPDATE: `${baseUrl}/${api_version}/timelapse-videos/update`,
        },
        SHARE_VIDEO: `${baseUrl}/${api_version}/timelapse-share-video`,
    },

    VIDEO: {
        HISTORY: `${baseUrl}/${api_version}/videos-history`,
        ZONE_HISTORY: `${baseUrl}/${api_version}/zone-history-advanced`,
        ZONE_HISTORY_ADVANCED: `${baseUrl}/${api_version}/zone-history-advanced`,
    },

    // ==================== Activity & Thresholds ====================
    ACTIVITY_THRESHOLDS: {
        BASE: `${baseUrl}/${api_version}/activity-thresholds`,
        FETCH: `${baseUrl}/${api_version}/activity-thresholds/fetch`,
        CREATE: `${baseUrl}/${api_version}/activity-thresholds/create`,
        MODIFY: `${baseUrl}/${api_version}/activity-thresholds/modify`,
        DELETE: `${baseUrl}/${api_version}/activity-thresholds/delete`,
    },

    THRESHOLD: {
        BASE: `${baseUrl}/${api_version}/threshold`,
        FETCH: `${baseUrl}/${api_version}/threshold/fetch`,
        CREATE: `${baseUrl}/${api_version}/threshold/create`,
        MODIFY: `${baseUrl}/${api_version}/threshold/modify`,
        DELETE: `${baseUrl}/${api_version}/threshold/delete`,
        INFO: `${baseUrl}/${api_version}/threshold-info`,
    },

    // ==================== Admin & Monitoring ====================
    ADMIN: {
        GATEWAY_STATS: `${baseUrl}/${api_version}/admin/device/customer-gateway-stats`,
        DISCONNECTED_BY_DATE: `${baseUrl}/${api_version}/admin/device/disconnected-by-date`,
    },

    // ==================== Storage & Files ====================
    S3_OPERATIONS: {
        BASE: `${baseUrl}/${api_version}/common-s3-operations`,
        SITEMAP_UPLOAD: `${baseUrl}/${api_version}/common-s3-operations/sitemap-upload`,
        UPLOAD_LOGO: `${baseUrl}/${api_version}/common-s3-operations/uploadLogo`,
    },

    DOC_VAULT: {
        FETCH: `${baseUrl}/${api_version}/doc-vault/fetchD`,
        DELETE: `${baseUrl}/${api_version}/doc-vault/delete`,
        MODIFY_SITEPLAN: `${baseUrl}/${api_version}/doc-vault/modify-siteplan`,
    },

    IMAGE: {
        RESOURCE: `${baseUrl}/${api_version}/image-resource`,
    },

    // ==================== BIM (Building Information Modeling) ====================
    BIM: {
        FETCH_OBJECTS: `${baseUrl}/${api_version}/bim/fetch-bim-objects`,
        MODIFY_OBJECTS: `${baseUrl}/${api_version}/bim/modify-bim-objects`,
    },

    // ==================== Events & Notifications ====================
    EVENT: {
        BASE: `${baseUrl}/${api_version}/event`,
        FETCH: `${baseUrl}/${api_version}/event/fetch`,
    },

    // ==================== Configuration ====================
    CONFIG: {
        BASE: `${baseUrl}/${api_version}/sitesupt-config`,
        PROCORE: `${baseUrl}/${api_version}/sitesupt-config/procore`,
    },

    // ==================== External Services ====================
    S3: {
        LOCATION_DATA_BUCKET: 'https://sitesupt-location-data.s3.amazonaws.com',
        TIMELAPSE_VIDEOS_BUCKET: 'https://sitesupt-timelaps-videos.s3.amazonaws.com',
    },

    GOOGLE: {
        MAPS: {
            GEOCODE: 'https://maps.googleapis.com/maps/api/geocode/json',
            TIMEZONE: 'https://maps.googleapis.com/maps/api/timezone/json',
            API_KEY: googleApiKey,
        },
        ANALYTICS: {
            ID: googleAnalyticsId,
        },
    },

    SALESFORCE: {
        URL: salesforceUrl,
        OPTS: salesforceOpts,
    },

    // ==================== Helper Methods ====================

    /**
     * Get full API URL for a given endpoint path
     * @param {string} endpoint - The endpoint path (e.g., '/auth/authenticate')
     * @returns {string} Full URL
     */
    getFullUrl(endpoint) {
        return `${baseUrl}/${api_version}${endpoint}`;
    },

    /**
     * Generate S3 image URL
     * @param {string} customerId - Customer ID
     * @param {string} siteId - Site ID
     * @param {string} locationId - Location ID
     * @param {string} deviceId - Device ID
     * @param {string} picTime - Picture timestamp
     * @returns {string} Full S3 image URL
     */
    getS3ImageUrl(customerId, siteId, locationId, deviceId, picTime) {
        return `${this.S3_LOCATION_DATA_BUCKET}/cusr_${customerId}/site_${siteId}/location_${locationId}/image_${deviceId}_${picTime}.jpg`;
    },

    /**
     * Generate S3 timelapse video URL
     * @param {string} siteId - Site ID
     * @param {string} locationId - Location ID
     * @param {string} fileName - Video file name
     * @returns {string} Full S3 timelapse URL
     */
    getS3TimelapseUrl(siteId, locationId, fileName) {
        return `${this.S3_TIMELAPSE_VIDEOS_BUCKET}/site_${siteId}/location_${locationId}/${fileName}`;
    },

    /**
     * Generate Google Maps geocoding URL
     * @param {string} address - Address or zip code to geocode
     * @returns {string} Full Google Maps API URL
     */
    getGeocodingUrl(address) {
        return `${this.GOOGLE_MAPS_GEOCODE}?address=${encodeURIComponent(address)}&key=${googleApiKey}`;
    },

    /**
     * Generate Google Maps timezone URL
     * @param {string} lat - Latitude
     * @param {string} lng - Longitude
     * @returns {string} Full Google Maps timezone API URL
     */
    getTimezoneUrl(lat, lng) {
        return `${this.GOOGLE_MAPS_TIMEZONE}?location=${lat},${lng}&key=${googleApiKey}`;
    },
};

export default SiteKickAPIService;